import HttpService from '../base.service/HttpService'

export default class DashboardService extends HttpService {
  getCardDashboardSpklu (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/cardDashboardSpklu'
    return this.get(param, api)
  }

  getChartDashboardSpklu (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/chartDashboardSpklu'
    return this.get(param, api)
  }

  getSpkluTransactionPercentage (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/persentaseTransaksiSpklu'
    return this.get(param, api)
  }

  getSpkluStatus (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/statusSpklu'
    return this.get(param, api)
  }
}
